import { Box } from "@mui/material";
import React from "react";
import type { ItemProps } from "react-virtuoso";
import { useListVirtualizedContext } from "./context";

export const VirtuosoItem = React.forwardRef(function VirtuosoItem<D>({ children, ...props }: ItemProps<D>, ref) {
  const { ListItem } = useListVirtualizedContext();

  return (
    <Box {...props} {...ListItem} ref={ref}>
      {children}
    </Box>
  );
});
